<template>
  <v-dialog
    v-if="settings?.pages?.exit?.active"
    v-model="dialog"
    max-width="650px"
    persistent
    content-class="exit-popup-dialog"
  >
    <v-card class="pa-0">
      <v-row no-gutters>
        <!-- Image Column -->
        <v-col cols="12" md="5" class="d-none d-md-block">
          <v-img
            :src="settings.pages.exit.content.image"
            height="100%"
            cover
            class="popup-image"
          ></v-img>
        </v-col>

        <!-- Content Column -->
        <v-col cols="12" md="7" class="pa-6 d-flex flex-column justify-center">
          <div class="text-center text-md-left">
            <h2
              class="text-h4 font-weight-bold mb-3"
              :style="{
                color: primaryColor || $vuetify.theme.themes.light.primary,
              }"
            >
              {{ this.localize("pages.exit.content.title") }}
            </h2>
            <p class="text-h6 font-weight-regular mb-4">
              {{ this.localize("pages.exit.content.subtitle") }}
            </p>
            <p class="text-body-1 mb-5">
              {{ this.localize("pages.exit.content.discountSubtitle") }}
            </p>

            <div class="text-center mb-6">
              <v-chip
                large
                :color="primaryColor || 'primary'"
                class="text-h5 font-weight-bold px-5 py-3"
                style="height: auto; letter-spacing: 1.5px; border-radius: 8px"
              >
                {{ settings.pages.exit.content.couponCode }}
              </v-chip>
            </div>

            <div class="text-center">
              <v-btn
                :color="primaryColor || 'primary'"
                dark
                large
                elevation="2"
                class="px-6 mb-2"
                @click="copyCode"
              >
                {{ copyButtonText }}
              </v-btn>
              <v-btn text small color="grey darken-1" @click="closeDialog">
                {{ $t("no_thanks") }}
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import FormattersMixin from "@/mixins/formatters-mixin";

export default {
  name: "ExitIntentPopup",
  mixins: [FormattersMixin],
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    primaryColor: {
      type: String,
      default: null,
    },
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      copyButtonText: this.$t("copy_code_continue"),
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    async copyCode() {
      try {
        await navigator.clipboard.writeText(
          this.settings.pages.exit.content.couponCode
        );
        this.copyButtonText = this.$t("copied");
        setTimeout(() => {
          this.closeDialog();
          setTimeout(() => {
            this.copyButtonText = this.$t("copy_code_continue");
          }, 500);
        }, 800);
      } catch (err) {
        console.error("Failed to copy code: ", err);
        alert(
          `${this.$t("failed_to_copy_code")}. ${this.$t(
            "please_copy_code_manually"
          )}: ${this.settings.pages.exit.content.couponCode}`
        );
        this.closeDialog();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.exit-popup-dialog {
  border-radius: 16px !important;
  overflow: hidden; /* Ensure image corners are clipped */
}

.v-card {
  border-radius: 0 !important; /* Remove default card radius since the dialog handles it */
}

/* .popup-image { } */

// Ensure consistent button height if needed
.v-btn {
  min-height: 48px;
}
</style>
